
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7609|8789|9850)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
